// TODO: Add support for multi-digit numbers
export const numberName = (value: number | string): string => {
  const i = parseInt(`${value}`);
  if (i === 9) return "nine";
  if (i === 8) return "eight";
  if (i === 7) return "seven";
  if (i === 6) return "six";
  if (i === 5) return "five";
  if (i === 4) return "four";
  if (i === 3) return "three";
  if (i === 2) return "two";
  if (i === 1) return "one";
  if (i === 0) return "zero";
  return `${value}`;
};

export default numberName;

const pr = new Intl.PluralRules("en-US", { type: "ordinal" });
const suffixes = new Map([
  ["one", "st"],
  ["two", "nd"],
  ["few", "rd"],
  ["other", "th"],
]);

export const numberOrder = (value: number | string): string => {
  const i = parseInt(`${value}`);
  if (i === 9) return "ninth";
  if (i === 8) return "eighth";
  if (i === 7) return "seventh";
  if (i === 6) return "sixth";
  if (i === 5) return "fifth";
  if (i === 4) return "fourth";
  if (i === 3) return "third";
  if (i === 2) return "second";
  if (i === 1) return "first";

  const rule = pr.select(i);
  const suffix = suffixes.get(rule);
  return `${value}${suffix}`;
};
